import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { CircleLoader, Panel } from "@nju/ui";
import { faqMachine } from "./faq.machine";
import { ActiveFaq } from "./partials/ActiveFaq/ActiveFaq";
import { Search } from "./partials/Search";
import { StaticFaq } from "./partials/StaticFaq/StaticFaq";

export function Faq() {
  const { query } = useRouter();
  const [current, send] = useMachine(faqMachine, {
    context: {
      activeCategoryId: query?.category as string | undefined,
      activeArticleId: query?.article as string | undefined,
    },
  });
  const {
    searchValue,
    categories,
    filteredArticles,
    articles,
    activeCategoryId,
    activeArticleId,
  } = current.context;

  const selectCategory = React.useCallback(
    (id: string | undefined) => {
      return send({ type: "SELECT_CATEGORY", id });
    },
    [send],
  );

  const setSearchValue = React.useCallback(
    (value: string) => {
      return send({ type: "SET_SEARCH_VALUE", value });
    },
    [send],
  );

  const clearSearch = React.useCallback(() => {
    return send({ type: "CLEAR_SEARCH" });
  }, [send]);

  if (current.matches("init")) {
    return (
      <div className="flex justify-center">
        <CircleLoader />
      </div>
    );
  }

  return (
    <Panel>
      <Search
        clearSearch={clearSearch}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      <div className="[&>ul]:pl-8 [&>ul]:list-disc [&>ol]:pl-8 [&>ol]:list-disc">
        {current.matches("empty") && (
          <StaticFaq
            activeArticleId={activeArticleId}
            activeCategoryId={activeCategoryId}
            articles={articles}
            categories={categories}
            selectCategory={selectCategory}
          />
        )}
        {current.matches("active") && (
          <ActiveFaq
            activeCategoryId={activeCategoryId}
            articles={filteredArticles}
            categories={categories}
            selectCategory={selectCategory}
          />
        )}
      </div>
    </Panel>
  );
}
